import type { RuntimeConfig } from "../types";

let cached: Promise<RuntimeConfig> | null = null;

function isRuntimeConfig(value: unknown): value is RuntimeConfig {
  if (typeof value !== "object" || value === null) return false;
  const v = value as Record<string, unknown>;
  return (
    typeof v.region === "string" &&
    typeof v.userPoolClientId === "string" &&
    typeof v.cognitoDomain === "string" &&
    Array.isArray(v.applicationUrls) &&
    v.applicationUrls.length > 0 &&
    v.applicationUrls.every((url) => typeof url === "string" && url.startsWith("https://"))
  );
}

/** Fetches and memoizes the deploy-time runtime config served at /config.json. */
export function loadRuntimeConfig(): Promise<RuntimeConfig> {
  if (!cached) {
    cached = fetch("/config.json", { cache: "no-store" })
      .catch(() => {
        throw new Error("Couldn't reach the server to load configuration.");
      })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Configuration failed to load (status ${res.status}).`);
        }
        return res.json();
      })
      .then((data) => {
        if (!isRuntimeConfig(data)) {
          throw new Error("Configuration response was missing required fields.");
        }
        return data;
      })
      .catch((err: unknown) => {
        cached = null;
        throw err instanceof Error ? err : new Error("Configuration failed to load.");
      });
  }
  return cached;
}
